// GAVION skip-callback (93_gavion_skip_callback.sql): « Sauter le rappel » and the « Demandé » / « Auto » labels.
export const callbacksFr = {
  kind: {
    requested: "Demandé",
    requested_hint: "La personne a demandé ce rappel",
    auto: "Auto",
    auto_hint:
      "Rappel automatique après un message laissé, une brochure ou une absence de réponse",
  },
  skip: {
    action: "Sauter le rappel",
    action_for: "Sauter le rappel de %{name}",
    reason_title: "Pourquoi ?",
    reasons: {
      inaccurate: "Inexact",
      already_done: "Déjà fait",
      not_relevant: "Plus pertinent",
    },
    done: "Rappel retiré",
    errors: {
      forbidden:
        "Seul le représentant assigné à cette compagnie ou un admin peut retirer ce rappel.",
      no_callback: "Cette compagnie n'a plus de rappel.",
      not_found: "Compagnie introuvable.",
      unknown: "Le rappel n'a pas pu être retiré. Réessayez.",
    },
  },
};
